import { combineReducers } from '@reduxjs/toolkit';
import routerReducer from '../router/router.slice';
import { AppReducer } from './app.reducer';
import { DbReducer } from './db.reducer';
import { DataReducer } from './data.reducer';
import { DeviceReducer } from './device.reducer';
import { UserReducer } from './user.reducer';

export const rootReducer = combineReducers({
  App: AppReducer,
  Db: DbReducer,
  Data: DataReducer,
  Device: DeviceReducer,
  User: UserReducer,
  router: routerReducer,
});
